module.exports = __webpack_public_path__ + "img/bm.c094b598.png";